import React,{useState,useEffect} from 'react';
import styled from '@emotion/styled';
import image from './cryptocurrencies.png';
import Form from './components/Form';
import Quote from "./components/Quote";
import axios from 'axios';
import Spiner from './spiner/Spiner';

const Container = styled.div`
max-width:900px;
margin:0px auto;
@media(min-width:992px){
  display:grid;
  grid-template-columns:repeat(2, 1fr);
  column-gap: 1rem;
}
`;
const Image = styled.img`
max-width:100%;
margin-top:5rem;
`;
const Heading = styled.h1`
font-family:'Bebas Neue', cursive;
color: #fff;
text-align: left;
font-weight: 700;
font-size: 50px;
margin-bottom: 50px;
margin-top: 80px;

&::after{
  content:'';
  width: 100px;
  height: 6px;
  background-color: #66a2ff;
  display:block;
}
`;


function App() {
  const [bitcurrency, updateCurrency] = useState('');
  const [bitcrypto, updateCrypto] = useState('');
  const [answer, setAnswer] = useState({});
  const [spiner, setSpiner] = useState(false);

  useEffect(() => {
    const quoteCrypto = async () => {
       if (bitcurrency === "") return;
       const url = `https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${bitcrypto}&tsyms=${bitcurrency}`;
      const answer = await axios.get(url);
      //mostar el spiner
      setSpiner(true);
      setTimeout(() => {
        //cargar el estado del spiner
        setSpiner(false);
        //guardar cotizacion
        setAnswer(answer.data.DISPLAY[bitcrypto][bitcurrency]);
      }, 3000);
      
      
    }
    quoteCrypto();
   
  }, [bitcurrency, bitcrypto, ]);
  //mostra el spiner o la cotizacion
  const component = (spiner) ? <Spiner /> : <Quote answer={answer} />;
  return (
    <Container>
      <div>
        <Image src={image} alt="cryptocurrencies" />
      </div>
      <div>
        <Heading>Quote Cryptocurrencies to the Instant</Heading>
        <Form
          updateCurrency={updateCurrency}
          updateCrypto={updateCrypto}
        />
        {component}
      </div>
    </Container>
  );
}

export default App;
